import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { CommissionPayablesPort } from "../../../app/ports/integration/commission-payables.port";
import { CommissionPayablesPageResponse } from "../../../domain/models/integration/commission-payables.model";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isCommissionPayablesPageResponse } from "../../validators/integration/commission-payables.validator";

@Injectable()
export class CommissionPayablesHttpAdapter implements CommissionPayablesPort {
  private static readonly PATH = "/api/v1/commission-payables/months";

  constructor(private readonly http: HttpClient, @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration) {}

  getMonths(page: number, size: number, typeBonusId?: number): Observable<CommissionPayablesPageResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    let params = new HttpParams().set("page", page).set("size", size);
    if (typeBonusId !== undefined) params = params.set("typeBonusId", typeBonusId);
    return this.http.get<unknown>(`${baseUrl}${CommissionPayablesHttpAdapter.PATH}`, { params }).pipe(
      map((response) => {
        if (!isCommissionPayablesPageResponse(response)) throw new Error("La respuesta de comisiones es inválida.");
        return response;
      }),
    );
  }
}
